import backendAxios from '../utils/backendAxios';
import {
  GET_NOTIFICATIONS,
  ADD_NOTIFICATION,
  MARK_NOTIFICATION_READ,
  UPDATE_INVITATION_STATUS,
  NOTIFICATION_ERROR
} from './types';

// Get all notifications
export const getNotifications = () => async dispatch => {
  try {
    const res = await backendAxios.get('/api/notifications');
    dispatch({
      type: GET_NOTIFICATIONS,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: NOTIFICATION_ERROR,
      payload: { msg: "Error al obtener notificaciones", status: 500 }
    });
  }
};

// Add notification (called from socket)
export const addNotification = (notification) => dispatch => {
  dispatch({
    type: ADD_NOTIFICATION,
    payload: notification
  });
};

// Mark as read
export const markAsRead = (id) => async dispatch => {
  try {
    const res = await backendAxios.patch(`/api/notifications/${id}/read`);
    dispatch({
      type: MARK_NOTIFICATION_READ,
      payload: id
    });
  } catch (err) {
    dispatch({
      type: NOTIFICATION_ERROR,
      payload: { msg: "Error al marcar como leída", status: 500 }
    });
  }
};

// Mark all as read
export const markAllAsRead = () => async dispatch => {
  try {
    await backendAxios.patch('/api/notifications/read-all');
    dispatch({
      type: 'MARK_ALL_NOTIFICATIONS_READ'
    });
  } catch (err) {
    dispatch({
      type: NOTIFICATION_ERROR,
      payload: { msg: "Error al marcar todas como leídas", status: 500 }
    });
  }
};

// Aceptar o rechazar una invitación desde su notificación. Devuelve { ok } o { ok: false, msg } con el motivo que da el servidor
// (ya respondida, ya no vigente…); en los dos casos la notificación queda con el estado que el servidor diga.
export const handleInvitation = (notificationId, action) => async dispatch => {
  try {
    const res = await backendAxios.post(`/api/notifications/${notificationId}/handle-invitation`, { action });

    dispatch({
      type: UPDATE_INVITATION_STATUS,
      payload: { id: notificationId, status: res.data.notification.status }
    });

    return { ok: true, ...res.data };
  } catch (err) {
    const actual = err.response?.data?.notification;
    if (actual?.status) {
      dispatch({ type: UPDATE_INVITATION_STATUS, payload: { id: notificationId, status: actual.status } });
    }
    dispatch({
      type: NOTIFICATION_ERROR,
      payload: { msg: "Error al procesar invitación", status: 500 }
    });
    return { ok: false, msg: err.response?.data?.msg || 'No se pudo guardar tu respuesta. Inténtalo de nuevo.' };
  }
};
